export default __webpack_public_path__ + "static/media/pop_sound.6bfe82aa.mp3";